// Carry Roll Classification — PSD §4.2.6. Shot shape + trajectory profile.
import { PROFILE_HIGH_MIN, PROFILE_LOW_MAX, SHAPE_MID_MAX, SHAPE_STRAIGHT_MAX } from './constants';
import { ShotShape, TrajectoryProfile } from './types';
/**
 * Classify shot shape from spin-axis tilt + total lateral curvature.
 * Positive curvature → right (fade/slice); negative → left (draw/hook).
 */
export function classifyShape(_spinAxisDeg, totalCurvatureDeg) {
    const warnings = [];
    const c = totalCurvatureDeg;
    let shape;
    if (Math.abs(c) < SHAPE_STRAIGHT_MAX) {
        shape = ShotShape.Straight;
    }
    else if (c >= SHAPE_MID_MAX) {
        shape = ShotShape.Slice;
    }
    else if (c <= -SHAPE_MID_MAX) {
        shape = ShotShape.Hook;
    }
    else if (c > 0) {
        shape = ShotShape.Fade;
    }
    else {
        shape = ShotShape.Draw;
    }
    return { shape, warnings };
}
/** Classify trajectory profile from apex/carry ratio. carry=0 → Mid default. */
export function classifyProfile(apexM, carryM) {
    const warnings = [];
    if (carryM <= 0) {
        return { profile: TrajectoryProfile.Mid, warnings };
    }
    const ratio = apexM / carryM;
    let profile;
    if (ratio < PROFILE_LOW_MAX) {
        profile = TrajectoryProfile.Low;
    }
    else if (ratio > PROFILE_HIGH_MIN) {
        profile = TrajectoryProfile.High;
    }
    else {
        profile = TrajectoryProfile.Mid;
    }
    return { profile, warnings };
}
//# sourceMappingURL=classify.js.map